import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../components/Button';
import Dialog from '../../../components/Dialog';

const ProjectWizardRequestEditDialog = ({
  visible,
  holderDisplayName,
  isWaiting,
  isRequesting,
  onCancel,
  onRequest,
}) => (
  <Dialog
    title="Project is being edited"
    visible={visible}
    onCancel={onCancel}
    footer={
      <div className="cluster-2">
        <Button data-testid="button-request-edit-cancel" onClick={onCancel}>
          Cancel
        </Button>
        {!isWaiting && (
          <Button
            data-testid="button-request-edit"
            type="primary"
            loading={isRequesting}
            onClick={onRequest}
          >
            Request edit access
          </Button>
        )}
      </div>
    }
  >
    {isWaiting ? (
      <p className="m-0 text-sm text-neutral-300 dark:text-neutral-300">
        Waiting for {holderDisplayName || 'the current editor'} to approve your
        request. You can continue browsing in view-only mode.
      </p>
    ) : (
      <p className="m-0 text-sm text-neutral-300 dark:text-neutral-300">
        {holderDisplayName || 'Another user'} is currently editing this project.
        You can cancel and keep viewing, or send a request for edit access.
      </p>
    )}
  </Dialog>
);

ProjectWizardRequestEditDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  holderDisplayName: PropTypes.string,
  isWaiting: PropTypes.bool,
  isRequesting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onRequest: PropTypes.func.isRequired,
};

ProjectWizardRequestEditDialog.defaultProps = {
  holderDisplayName: '',
  isWaiting: false,
  isRequesting: false,
};

export default ProjectWizardRequestEditDialog;
